// Минимальный файл для webpack сборки
console.log('API сервис corpent');
